export default "__VITE_ASSET__R_LNIG01__"